// IANA zone ids so dayjs (via Intl) resolves the correct UTC offset per date,
// DST included - covering the US, Europe, India, China, and other major
// Asian business hubs per the Activity Logs timezone selector.
export const TIME_ZONES = [
  { value: "UTC", label: "UTC (Coordinated)" },
  { value: "America/New_York", label: "New York (ET)" },
  { value: "America/Chicago", label: "Chicago (CT)" },
  { value: "America/Denver", label: "Denver (MT)" },
  { value: "America/Los_Angeles", label: "Los Angeles (PT)" },
  { value: "Europe/London", label: "London (GMT/BST)" },
  { value: "Europe/Paris", label: "Paris (CET)" },
  { value: "Europe/Berlin", label: "Berlin (CET)" },
  { value: "Europe/Moscow", label: "Moscow (MSK)" },
  { value: "Asia/Kolkata", label: "India (IST)" },
  { value: "Asia/Shanghai", label: "China (CST)" },
  { value: "Asia/Hong_Kong", label: "Hong Kong (HKT)" },
  { value: "Asia/Tokyo", label: "Tokyo (JST)" },
  { value: "Asia/Seoul", label: "Seoul (KST)" },
  { value: "Asia/Singapore", label: "Singapore (SGT)" },
  { value: "Asia/Dubai", label: "Dubai (GST)" },
  { value: "Asia/Bangkok", label: "Bangkok (ICT)" },
  { value: "Australia/Sydney", label: "Sydney (AEST)" },
];

export const DEFAULT_TIME_ZONE = "UTC";
